import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Box, Button, Stack } from '@mui/material';
import { useEntityActions } from 'api/entity';
import EditableTextField from 'components/editableTextField';
import { EncryptedDescription } from 'pages/finsightEntity/components/EncryptedDescription';
import React, { useState } from 'react';
import { FinsightEntity } from 'shared';

export type EntityDescriptionProps = {
  entity: FinsightEntity;
};

export function EntityDescription({ entity }: EntityDescriptionProps) {
  const [showRaw, setShowRaw] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  const { updateEntity } = useEntityActions();

  if (entity.types[0] === 'encrypted_data' && !showRaw) {
    return (
      <>
        <EncryptedDescription entity={entity} />
        <Button sx={{ alignSelf: 'flex-end' }} onClick={() => setShowRaw(true)}>
          Show Raw
        </Button>
      </>
    );
  }

  return (
    <Stack gap={1}>
      <Box
        sx={{
          maxHeight: isExpanded || isFocused ? 'none' : '200px',
          overflow: isExpanded || isFocused ? 'visible' : 'hidden',
          position: 'relative',
        }}
      >
        <EditableTextField
          rich
          key={entity.id}
          fullWidth
          minRows={5}
          variant="outlined"
          value={entity.description ?? ''}
          placeholder="No description added, type here to add one"
          onChange={async (v) => {
            await updateEntity(entity.id, { description: v });
          }}
          onFocus={() => {
            setIsFocused(true);
          }}
          onBlur={() => {
            setIsFocused(false);
          }}
        />
      </Box>
      <Button
        startIcon={isExpanded ? <ExpandLess /> : <ExpandMore />}
        onClick={() => setIsExpanded(!isExpanded)}
        sx={{ alignSelf: 'flex-start' }}
        size="small"
      >
        {isExpanded ? 'Show Less' : 'Show More'}
      </Button>
    </Stack>
  );
}
